module.exports = __webpack_public_path__ + "img/phone-x.a5bb5349.svg";